import { defineStore } from 'pinia'
import { ref } from 'vue'

import { DynamicItemType, DynamicNodeAttrs } from '@/types'

export const useEditorStore = defineStore('editor', () => {
  const isFullscreen = ref(false)
  const color = ref<string>()
  const highlight = ref<string>()
  const AIMenu = ref(false)
  const showPreview = ref(false)
  const spellCheck = ref(false)
  const findAndReplace = ref(false)
  const printer = ref(false)
  const editable = ref(false)

  const dynamicPlaceholders = ref<string[]>([])
  const dynamicPlaceholdersFor = ref<string[]>([])
  const dynamicPlaceholdersForValues = ref<string[]>([])
  const dynamicPlaceholdersLoading = ref(false)
  const dynamicDialogType = ref<DynamicItemType | null>(null)
  const dynamicDialogAttrs = ref<DynamicNodeAttrs | undefined>(undefined)
  const dynamicDialogCallback = ref<((attrs: DynamicNodeAttrs) => void) | null>(null)

  function toggleFullscreen() {
    isFullscreen.value = !isFullscreen.value
  }

  function togglePreview() {
    showPreview.value = !showPreview.value
  }

  function toggleSpellCheck() {
    spellCheck.value = !spellCheck.value
  }

  function toggleFindAndReplace() {
    findAndReplace.value = !findAndReplace.value
  }

  function togglePrinter() {
    printer.value = !printer.value
  }

  function toggleHighlight(color?: string) {
    highlight.value = color
  }

  function setEditable(isEditable: boolean) {
    editable.value = isEditable
  }

  return {
    isFullscreen,
    color,
    highlight,
    AIMenu,
    showPreview,
    spellCheck,
    findAndReplace,
    printer,
    editable,

    dynamicPlaceholders,
    dynamicPlaceholdersFor,
    dynamicPlaceholdersForValues,
    dynamicPlaceholdersLoading,
    dynamicDialogType,
    dynamicDialogAttrs,
    dynamicDialogCallback,

    toggleFullscreen,
    togglePreview,
    toggleSpellCheck,
    toggleFindAndReplace,
    toggleHighlight,
    togglePrinter,
    setEditable,
  }
})
